module.exports = __webpack_public_path__ + "static/media/94i881.1fd00a47.png";